
const { createApp, ref } = Vue;

let colorMatchDebug = false;

function colorMatchLogger(...data) {
  if (colorMatchDebug) console.log(...data);
}

// (() => {
//   const sectionHeader = document.querySelector("#shopify-section-header-inline-new");

//   window.addEventListener("scroll", () => {
//     if (window.scrollY > 70) {
//       sectionHeader.classList.add("shopify-section-header-hidden")
//     } else {
//       sectionHeader.classList.remove("shopify-section-header-hidden")
//     }
//   })
// })();

let colorMatchVue = new Vue({
  el: '.color-match-container',
  delimiters: ['${', '}'],
  data() {
    return {
      // 开始搭配
      isStartMatch: false,
      // 展示轮播图
      isShowSwiper: false,
      // 显示产品侧面
      isShowSideView: false,
      // 是否正在加购中
      isSaving: false,
      isShowSeriesDropdown: false,
      mySwiper: null,
      categories: [
        // {
        //   groupId: 1,
        //   title: "Model",
        //   icon: "",
        //   uiType: "default",
        //   children: [
        //     { title: "iPhone 15", "series": "Apple iPhone 15 Series" },
        //   ]
        // },
      ],
      // 按产品分组，内部 Options 相当于图片的排列组合，并包含了产品变体 Id
      optionsList: [
        // {
        //   groupId: 1,
        //   options: [
        //     { groupId: 1, image: '', imageBack: '', productTitle: '', variant: {}, variantId: 114514, option: {"Model": "iPhone 15", "Case": "Snap Case MOVAS™"}}
        //   ]
        // },
      ],
      // 多个产品的全部变体列表，每个 groupId 对应一个 Product
      productsVariants: [
        // {groupId: 1, variants: []}
      ],
      // 多个产品的变体选项，每个 groupId 对应一个 Product
      productOptions: [
        // {groupId: 1, options: []}
      ],
      // 当前展示的 Swiper 图片列表
      expandedFirstCategoryIndex: -1,
      currentGroupId: 1,
      // 当前已选变体（核心变量）
      selectedGroupsVariant: [
        // {groupId, variantId, optionId?: string}
      ],
      // 轮播图图片列表，结构与 optionsList[n].options 内相同
      currentSwiperImageList: [],
      isReloadingSwiper: false, // Swiper 是否正在重新加载，切换一级目录会触发
      currentSeries: null,
      defaultOptions: [],
    }
  },
  computed: {
    // 当前已选搭配
    selectedGroupsOption() {
      const result = [];
      for (const item of this.selectedGroupsVariant) {
        const groupId = item.groupId;
        const variantId = item.variantId;
        const optionId = item.optionId;
        const findOptions = this.optionsList.find((v) => v.groupId == groupId)?.options;
        const findOption = findOptions.find((v) => optionId ? (v.optionId == optionId) : (v.variantId == variantId));
        result.push(findOption);
      }
      return result;
    },
    // 一级菜单的已选项
    firstCaregorySelectValue() {
      return function (item) {
        const option = this.selectedGroupsOption.find((v) => v.groupId == item.groupId)?.option;
        const value = option ? option[item.title] : undefined;
        return value ? value : item.children[0].title;
      }
    },
    // 二级菜单的高亮
    secondCaregorySelected() {
      return function (item, subItem) {
        const findOption = this.selectedGroupsOption.find((v) => v.groupId == item.groupId);
        return findOption && findOption.option[item.title] == subItem.title;
      }
    },
    // 二级菜单的禁用状态
    secondCaregoryDisabled() {
      return function (item, subItem) {
        const findOption = this.currentSwiperImageList.find((v) => (v.groupId == item.groupId) && (v.option[item.title] == subItem.title));
        colorMatchLogger(findOption);
        return !findOption;
      }
    },
    currentPriceLabel() {
      colorMatchLogger(this.selectedGroupsOption);
      const price = this.selectedGroupsOption.reduce((prev, curr) => prev + curr.variant?.price ?? 0, 0) / 100;
      const formatPrice = (price)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      return isNaN(price) ? '' : formatPrice;
    },
    /**
     * 当前商品的销售状态
     * @return {'normal'} 正常销售
     * @return {'out_of_stock'} 售罄
     */
    saleStatus() {
      let status = 'normal';
      for (const groupOption of this.selectedGroupsOption) {
        if (!groupOption.variant?.available) {
          status = 'out_of_stock';
          break;
        }
      }
      return status;
    },
    seriesList() {
      let array = [];
      for (const item of this.categories[0].children) {
        if (!array.includes(item.series)) {
          array.push(item.series);
        }
      }
      return array;
    }
  },
  beforeMount() {
    this.initData();
  },
  mounted() {
    // 设置初始（默认）的搭配
    // 获取 Color match default options 模块的 blocks，生成默认搭配
    const default_options_bk_stts_list_json = document.querySelector(`[data-color-match-default-options]`);
    const default_options_bk_stts_list = JSON.parse(default_options_bk_stts_list_json.innerHTML);
    const defaultOptions = [];
    for (const default_options_bk_stts of default_options_bk_stts_list) {
      const groupId = default_options_bk_stts.group_id;
      const option = {};
      // 遍历 Block 的所有 Category Option
      for (let i = 1; i < 100; i++) {
        const optionStr = default_options_bk_stts[`category_option_${i}`];
        if (!optionStr || !optionStr.includes(":")) break; // 没有了，不再进行
        const categoryOptionKey = optionStr.split(":")[0]?.trim();
        const categoryOptionValue = optionStr.split(":")[1]?.trim();
        option[categoryOptionKey] = categoryOptionValue;
      }
      const findOption = this.optionsList.find((g) => g.groupId == groupId).options.find((opt) => this.optionEqual(opt.option, option));
      if (findOption == null) {
        console.error('Default option not found: ', default_options_bk_stts);
        alert(`Default option not found! \nOption: ${JSON.stringify(option)}`);
      } else if (findOption?.variantId == null) {
        console.error('Variant not found for default options! Default options settigns: ', default_options_bk_stts);
      }
      defaultOptions.push({
        groupId: groupId,
        option: option,
        optionId: findOption.optionId,
        variantId: findOption.variantId,
      });
    }
    this.defaultOptions = defaultOptions;
    let groupIdList = [];
    // 找寻对应的变体
    for (const item of defaultOptions) {
      if (!groupIdList.includes(item.groupId)) {
        this.selectedGroupsVariant.push({ groupId: item.groupId, variantId: item.variantId, optionId: item.optionId });
      }
      groupIdList.push(item.groupId);
    }

    this.updateCurrentSwiperImageList();

    // 跳过首屏
    if (this.settings.skip) {
      this.handleClickStart();
    }
  },
  methods: {
    randomUUID() {
      return (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : Math.random().toString(36).substr(2, 9);
    },
    // 对比两个选项是否相等 (不严谨版)
    optionEqual(obj1, obj2) {
      for (const key in obj1) {
        const value1 = obj1[key]?.trim();
        const value2 = obj2[key]?.trim();
        if (value1 != value2) return false;
      }
      return true;
    },
    // 初始化数据
    initData() {
      // 主设置
      const mainSettings = JSON.parse(document.querySelector(`.section_settings[data-color-match-container]`).innerHTML);
      this.settings = mainSettings;

      // 产品变体
      const pr_variants_json_list = document.querySelectorAll(`.pr_variants_json[data-color-match-option]`);
      for (const item of pr_variants_json_list) {
        const pr_variants = JSON.parse(item.innerHTML);
        const group_id = item.getAttribute("data-group-id");
        const findCategoryIndex = this.productsVariants.findIndex((v) => v.groupId == group_id);
        if (findCategoryIndex < 0) {
          // 收集产品变体集
          this.productsVariants.push({ groupId: group_id, variants: pr_variants });
        }
      }
      // 产品变体选项
      const pr_options_json_list = document.querySelectorAll(`.pr_options_json[data-color-match-option]`);
      for (const item of pr_options_json_list) {
        const pr_options = JSON.parse(item.innerHTML);
        const group_id = item.getAttribute("data-group-id");
        const findCategoryIndex = this.productOptions.findIndex((v) => v.groupId == group_id);
        if (findCategoryIndex < 0) {
          this.productOptions.push({ groupId: group_id, options: pr_options });
        }
      }


      const se_stts_json_list = document.querySelectorAll(`.section_settings[data-color-match-option]`);
      // 遍历 Section 
      for (const item of se_stts_json_list) {
        const se_stts = JSON.parse(item.innerHTML);
        const group_id = se_stts.group_id;
        const section_id = item.getAttribute("data-section-id");
        // blocks
        const bk_stts_list_json = document.querySelector(`.blocks_settings[data-color-match-option][data-group-id="${group_id}"][data-section-id=${section_id}]`);
        const bk_stts_list = JSON.parse(bk_stts_list_json.innerHTML);
        // 遍历 Block 
        for (const bk_stts of bk_stts_list) {
          const blockOption = {};
          // 遍历 Block 的所有 Category Option
          for (let i = 1; i < 100; i++) {
            const option = bk_stts[`category_option_${i}`];
            if (!option || !option.includes(":")) break; // 没有了，不再进行
            const categoryOptionKey = option.split(":")[0]?.trim();
            const categoryOptionValue = option.split(":")[1]?.trim();
            blockOption[categoryOptionKey] = categoryOptionValue;
          }

          // 遍历 Block 的所有 Variant Option，获取变体Id
          let variantId;
          const findVariants = this.productsVariants.find((v) => v.groupId == group_id)?.variants ?? [];
          let findVariant;
          // 提取 variantId
          if (bk_stts.variant_id != "" && bk_stts.variant_id != null) {
            variantId = bk_stts.variant_id;
            findVariant = findVariants.find((variant) => variant.id == variantId);
            if (findVariant == null || variantId == null) {
              console.error('Variant not found by variant id!', {
                findVariants: findVariants,
                findVariant: findVariant,
                bk_stts: bk_stts,
                group_id: group_id,
              });
            }

          } else {
            try {
              // 遍历产品 option，有点复杂
              const variantOptions = [
                // {
                //   name: "",
                //   value: "",
                //   position: 1,
                // }
              ];
              const productOptions = this.productOptions.find((v) => v.groupId == group_id)?.options;
              for (let i = 1; i < 100; i++) {
                const variantoption = bk_stts[`variant_option_${i}`];
                if (!variantoption || !variantoption.includes(":")) break; // 没有了，不再进行
                const variantoptionKey = variantoption.split(":")[0]?.trim();
                const variantoptionValue = variantoption.split(":")[1]?.trim();
                const findPosition = productOptions?.find((v) => v.name == variantoptionKey)?.position;
                variantOptions.push({
                  name: variantoptionKey,
                  value: variantoptionValue,
                  position: findPosition,
                });
              }
              if (variantOptions.length != 0) {
                const productsVariants = this.productsVariants.find((v) => v.groupId == group_id)?.variants;
                findVariant = productsVariants?.find((variant) => {
                  let isResult = true;
                  for (const vo of variantOptions) {
                    if (variant.options[vo.position - 1] != vo.value) {
                      isResult = false;
                      break;
                    }
                  }
                  return isResult;
                });
                variantId = findVariant?.id;
                if (!findVariant) {
                  console.error('Variant not found by options!', {
                    product_title: bk_stts.title,
                    findVariants: findVariants,
                    findVariant: findVariant,
                    bk_stts: bk_stts,
                    group_id: group_id,
                    variantOptions: variantOptions,
                  });
                  // alert(`Variant not found!. \nProduct title in block: "${bk_stts.title}". \nOptions: ${JSON.stringify(variantOptions)}.`);
                }
              } else {
                // 没提供变体信息
                console.error('Variant not found, without options!', {
                  product_title: bk_stts.title,
                  findVariants: findVariants,
                  findVariant: findVariant,
                  bk_stts: bk_stts,
                  group_id: group_id,
                  variantOptions: variantOptions,
                });
                // alert(`Variant not found, without options! \nProduct title in block: "${bk_stts.title}".`);
              }
            } catch (error) {
              console.error("initData(), find variant error,", error);
            }
          }

          // Block
          // 生成 Options
          const findOptionImagesIndex = this.optionsList.findIndex((v) => v.groupId == group_id);
          if (findOptionImagesIndex > -1) {
            // 已有，添加子集
            this.optionsList[findOptionImagesIndex].options.push({
              groupId: group_id,
              variantId: variantId,
              image: bk_stts.image_1,
              imageBack: bk_stts.image_1_back,
              productTitle: bk_stts.title,
              variant: findVariant,
              option: blockOption,
              optionId: this.randomUUID(),
            });
          } else {
            // 无，新建
            this.optionsList.push({
              groupId: group_id,
              options: [{
                groupId: group_id,
                variantId: variantId,
                image: bk_stts.image_1,
                imageBack: bk_stts.image_1_back,
                productTitle: bk_stts.title,
                variant: findVariant,
                option: blockOption,
                optionId: this.randomUUID(),
              }]
            });
          }
        }
      }

      // 获取 Color match container 模块的 blocks，生成目录和子目录
      const container_bk_stts_list_json = document.querySelector(`.blocks_settings[data-color-match-container]`);
      const container_bk_stts_list = JSON.parse(container_bk_stts_list_json.innerHTML);
      for (const container_bk_stts of container_bk_stts_list) {
        if (container_bk_stts.type == "category") {
          // 生成目录 Main category
          this.categories.push({
            groupId: container_bk_stts.group_id,
            title: container_bk_stts.title,
            icon: container_bk_stts.icon,
            uiType: container_bk_stts.ui_type,
            children: [],
          });
        } else if (container_bk_stts.type == "sub_category") {
          // 生成子目录 Sub-category
          const forMainTitle = container_bk_stts.for_main_title;
          this.categories.find((v) => v.title == forMainTitle)?.children.push({
            title: container_bk_stts.title,
            icon: container_bk_stts.icon,
            series: container_bk_stts.series,
          });
        }
      }

      this.currentSeries = this.seriesList[0];
    },
    initSwiper() {
      this.mySwiper = new Swiper(".color-match__design-studio .swiper-container", {
        slidesPerView: 'auto',
        centeredSlides: true,
        grabCursor: true,
        simulateTouch: true, // 鼠标滑动
        speed: 500,
        // slideToClickedSlide: true, // 点击 Slide 跳转 （鼠标与 simulateTouch 冲突）
        // spaceBetween: 32,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        // scrollbar: {
        //   el: `${sectionSelector} .rs_scrollbar`,
        // },
        navigation: {
          nextEl: `.btn-swiper-right`,
          prevEl: `.btn-swiper-left`,
        },
        observer: true,
        resizeObserver: true,
        breakpoints: {
          1000: {
          },
          680: {
          }
        },
        on: {
          sliderMove: this.handleSwiperSliderMove,
          slideChange: this.handleSwiperChanged,
        }
      });
    },
    // 重置当前已选项/变体为第一个变体
    resetVariant(groupId) {
      const findOptions = this.optionsList.find((v) => v.groupId == groupId);
      const selectedGroupVariant = this.selectedGroupsVariant.find((v) => v.groupId == groupId);
      selectedGroupVariant.variantId = findOptions.options[0].variantId;
      colorMatchLogger("reset variant: ", groupId);
    },
    // 更新当前展示的 Swiper 图片列表
    updateCurrentSwiperImageList() {
      let result = [];
      const findOptions = this.optionsList.find((v) => v.groupId == this.currentGroupId)?.options ?? [];
      const selectedOption = this.selectedGroupsOption.find((v) => v.groupId == this.currentGroupId);

      // 优化改进
      const currentMainCategoryTitle = this.categories[this.expandedFirstCategoryIndex]?.title;
      result = findOptions;
      for (const category of this.categories.filter((ca) => ca.groupId == this.currentGroupId)) {
        if (currentMainCategoryTitle != category.title) {
          result = findOptions.filter((v) => v.option[category.title] == selectedOption.option[category.title]);
          if (!!this.currentSeries) {
            // find series
            result = result.filter((v) => this.isOptionInSeries(v.option));
          }
        }
      }
      // 为特定的一级菜单的图片列表进行额外过滤
      if (currentMainCategoryTitle == "Model") {
        result = result.filter((v) => v.option["Color"] == selectedOption.option["Color"]);
      }
      if (currentMainCategoryTitle == "Case") {
        result = result.filter((v) => v.option["Model Color"] == selectedOption.option["Model Color"]);
      }

      this.currentSwiperImageList = result;
    },
    isOptionInSeries(option) {
      const title = option["Model"];
      const findSubCategory = this.categories[0].children.find((child) => child.series == this.currentSeries && child.title == title);
      return findSubCategory;
    },
    handleClickSeries(series) {
      this.currentSeries = series;
      this.isShowSeriesDropdown = false
      this.isShowSideView = false;
      this.isReloadingSwiper = true; // 先触发动画效果

      // 动画进行到一半，开始计算和更新
      setTimeout(() => {
        // 切换变体
        if (this.selectedGroupsVariant[0].variantId) {
          for (const defaultOption of this.defaultOptions) {
            if (this.isOptionInSeries(defaultOption.option)) {
              this.selectedGroupsVariant[0].variantId = defaultOption.variantId;
              this.selectedGroupsVariant[0].optionId = defaultOption.optionId;
            }
          }
        }
        if (this.expandedFirstCategoryIndex > -1) {
          // this.isShowSwiper = true;
          // 分类已展开
          this.updateCurrentSwiperImageList();
        }
        this.expandedFirstCategoryIndex = -1;
        this.isShowSwiper = false;
      }, 500);
      setTimeout(() => {
        this.resetSwiperIndex();
      }, 600);
      // 动画结束
      setTimeout(() => {
        this.isReloadingSwiper = false;
        this.$nextTick(() => {
          this.categoryScrollIntoView();
        });
      }, 1000);
    },
    // 点击一级菜单
    handleClickCategoryFirst(event, item, itemIndex) {
      const secondEl = event.currentTarget.querySelector(".category-list--second");
      if (this.expandedFirstCategoryIndex == itemIndex) {
        // 避免点击二级菜单触发一级
        return;
      }
      this.isShowSideView = false;
      this.isReloadingSwiper = true; // 先触发动画效果

      // 动画进行到一半，开始计算和更新
      setTimeout(() => {
        this.isShowSwiper = true;
        this.expandedFirstCategoryIndex = itemIndex;
        this.currentGroupId = item.groupId;
        const width = secondEl?.scrollWidth;
        secondEl.style.maxWidth = width + 'px';
        // 更新轮播图图片列表
        this.updateCurrentSwiperImageList();
      }, 500);
      setTimeout(() => {
        // Swpier 索引归位
        this.resetSwiperIndex();
      }, 600);
      // 动画结束
      setTimeout(() => {
        this.isReloadingSwiper = false;
        this.$nextTick(() => {
          this.categoryScrollIntoView();
        });
      }, 1000);
    },
    // 点击二级菜单
    handleClickCategorySecond(event, item, subItem, itemIndex) {
      const el = event.currentTarget;
      const firstTite = item.title;
      const secondTitle = subItem.title;
      const findSwiperOptionIndex = this.currentSwiperImageList.findIndex((v) => v.groupId == this.currentGroupId && v.option[firstTite] == secondTitle);
      this.mySwiper.slideTo(findSwiperOptionIndex, 500);
      colorMatchLogger(firstTite, secondTitle, "slideTo", findSwiperOptionIndex);

      if (window.innerWidth <= 589) {
        // 菜单栏滑动到下一个一级菜单
        this.$nextTick(() => {
          this.categoryScrollIntoNext();
        });
      }
    },
    // 点击一级菜单上拉框，展示二级菜单
    handleSelectCategoryShow(event, item, itemIndex) {
      const element = event.target.closest('.category-item--first');
      element && this.categoryScrollIntoView(element);
    },
    // 上拉选项选择二级菜单
    handleSelectChangeCategorySecond(event, item, itemIndex) {
      const firstTite = item.title;
      const secondTitle = event.detail.value;

      // 未展开二级菜单则先展开
      if (this.currentGroupId != item.groupId) {
        this.isShowSideView = false;
        this.isReloadingSwiper = true; // 先触发动画效果

        // 动画进行到一半，开始计算和更新
        setTimeout(() => {
          this.isShowSwiper = true;
          this.expandedFirstCategoryIndex = itemIndex;
          this.currentGroupId = item.groupId;
          // 更新轮播图图片列表
          this.updateCurrentSwiperImageList();
        }, 500);
        setTimeout(() => {
          // Swpier 索引归位
          const findSwiperOptionIndex = this.currentSwiperImageList.findIndex((v) => v.groupId == this.currentGroupId && v.option[firstTite] == secondTitle);
          this.mySwiper.slideTo(findSwiperOptionIndex, 0);
        }, 600);
        // 动画结束
        setTimeout(() => {
          this.isReloadingSwiper = false;
          this.$nextTick(() => {
            this.categoryScrollIntoView();
          });
        }, 1000);
      } else {
        const findSwiperOptionIndex = this.currentSwiperImageList.findIndex((v) => v.groupId == this.currentGroupId && v.option[firstTite] == secondTitle);
        this.mySwiper.slideTo(findSwiperOptionIndex, 500);
      }
    },
    // 菜单栏滑动到下一个一级菜单
    categoryScrollIntoNext() {
      const container = document.querySelector('.categories-bar');
      const el = document.querySelector('.category-item--first.is--expanded + .category-item--first');
      const containerWidth = container.clientWidth;
      if (el) {
        const itemLeft = el.offsetLeft;
        const scrollLeft = itemLeft - containerWidth / 2 + el.clientWidth / 2;
        container.scroll({
          left: scrollLeft,
          behavior: 'smooth'
        });
        el.click();
      }
    },
    // 分类导航栏滚动到当前子分类的位置
    categoryScrollIntoView(element) {
      const container = document.querySelector('.categories-bar');
      const categoryElement = document.querySelector(`.categories-bar .category-item[data-category-index="${this.expandedFirstCategoryIndex}"]`);
      let el = element ?? categoryElement.querySelector(`.category-item--second.is--selected`);
      if (window.innerWidth <= 590 && categoryElement.classList.contains('category-item--mb-select')) {
        // 移动端上拉选项
        el = categoryElement;
      }
      const containerLeft = container.scrollLeft;
      const containerWidth = container.clientWidth;
      if (el) {
        const itemLeft = el.offsetLeft;
        const itemWidth = el.offsetWidth;
        colorMatchLogger(containerLeft, containerWidth, itemLeft, itemWidth);
        const scrollLeft = itemLeft - containerWidth / 2 + el.clientWidth / 2;
        container.scroll({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    },
    // Swpier 归位
    resetSwiperIndex() {
      // 在轮播图列表中找寻符合当前已选项的轮播图，跳转到该轮播图
      const selectedOption = this.selectedGroupsOption.find((v) => v.groupId == this.currentGroupId);
      const findSwiperOptionIndex = this.currentSwiperImageList.findIndex((v) => v.variantId == selectedOption.variantId && v.optionId == selectedOption.optionId);
      if (this.mySwiper.activeIndex != findSwiperOptionIndex) {
        this.mySwiper.slideTo(findSwiperOptionIndex, 0, false);
        colorMatchLogger("reloadSwiper slideTo:", findSwiperOptionIndex);
      }
    },
    // 监听拖动播图事件
    handleSwiperSliderMove() {
      this.isShowSideView = false;
    },
    // 监听切换轮播图事件
    handleSwiperChanged() {
      this.isShowSideView = false;
      if (this.isReloadingSwiper) return; // Swiper 重载中，不要改变当前选项
      const activeIndex = this.mySwiper.activeIndex;
      colorMatchLogger("handleSwiperChanged", activeIndex);
      const groupId = this.currentGroupId;
      const variantId = this.currentSwiperImageList[activeIndex].variantId;
      const optionId = this.currentSwiperImageList[activeIndex].optionId;
      const selectedGroupVariantIndex = this.selectedGroupsVariant.findIndex((v) => v.groupId == groupId);
      this.selectedGroupsVariant[selectedGroupVariantIndex].optionId = optionId;
      this.selectedGroupsVariant[selectedGroupVariantIndex].variantId = variantId;
      this.selectedGroupsVariant = [...this.selectedGroupsVariant];

      this.$nextTick(() => {
        this.categoryScrollIntoView();
      });
    },
    // 点击轮播图
    handleClickSwiperSlide(item, itemIndex) {
      this.mySwiper.slideTo(itemIndex, 500);
    },
    // 开始搭配
    handleClickStart() {
      this.isStartMatch = true;
      this.$nextTick(() => {
        this.initSwiper();
        setTimeout(() => {
          this.runCategoryFirstAnimate();
        }, 1000);
      });
    },
    // 执行初始动画（第一个分类展开后收缩）
    runCategoryFirstAnimate() {
      const firstCategory = document.querySelector(".categories-bar>.category-item--first");
      const secondCategoryList = document.querySelector(".categories-bar .category-list--second");
      const secondCategoryFirstChild = document.querySelector(".categories-bar .category-list--second>.category-item--second:first-child .category-item__title");
      secondCategoryList.style.maxWidth = secondCategoryFirstChild.clientWidth + 'px';
      firstCategory.classList.add('is--first-expanded-animate');
      setTimeout(() => {
        secondCategoryList.style.maxWidth = '0px';
        setTimeout(() => {
          firstCategory.classList.remove('is--first-expanded-animate');
          secondCategoryList.style.maxWidth = '';
        }, 500); // 结束动画的执行时间，要在动画结束后才能移除类名
      }, 1500);
    },
    // 展示产品另一侧
    handleClickSideView() {
      this.isShowSideView = !this.isShowSideView;
    },
    handleClickSave() {
      let formData = {
        'items': [
          // {'id': 36110175633573, 'quantity': 2},
        ]
      };
      for (const item of this.selectedGroupsVariant) {
        formData.items.push({
          id: item.variantId,
          quantity: 1,
        });
      }
      this.isSaving = true;
      // 加购
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          colorMatchLogger(response);
          if (response.status == 422) {
            alert("Product out Of Stock!");
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          // 更新购物车
          T4SThemeSP.Cart.getToFetch().finally(() => {
            this.isSaving = false;
            document.querySelector(".t4s-site-nav__cart > a").click();
            // $(".t4s-site-nav__cart a").trigger('click.drawer');
          });
        });
    },
  }
});